import './PendingMovement.scss';
import { useEffect, useState } from 'react';
import { formatDate } from '../../utils/dateHelper/dateHelper';
import Hub from '../../api/controllers/Hub/Hub';
import AssociatedPackageList from './subComponents/AssociatedPackageList/AssociatedPackageList';
import AssignmentList from './subComponents/AssignmentList/AssignmentList';
import Modal from '../../common/Modal/Modal';
import GoodsIn from '../../api/controllers/GoodsIn/GoodsIn';
import GoodsOut from '../../api/controllers/GoodsOut/GoodsOut';
import EditBay from '../../common/EditBay/EditBay';
import PrintLabel from '../../common/PrintLabel/PrintLabel';
import MovementDetails from '../../common/MovementDetails/MovementDetails';
import MovementNotesPhotos from '../../common/MovementNotesPhotos/MovementNotesPhotos';
import PropTypes from 'prop-types';
import StartModal from './subComponents/StartModal/StartModal';
import Job from '../../api/controllers/Job/Job';
import Button from '../../common/Button/Button';
import Error from '../../common/Error/Error';

// PendingMovement screen Component
const PendingMovement = ({
  setFromPending,
  getMovement,
  movement,
  setError,
  setLoading,
  category,
  movementType,
}) => {
  const [baysAndRacks, setBaysAndRacks] = useState();
  const [bays, setBays] = useState();
  const [racks, setRacks] = useState();
  const [firstJob, setJob] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const jobs = movement?.assignments
    ?.map(assignment => assignment.job)
    .filter((x, i, a) => a.indexOf(x) == i);

  const getJob = () => {
    setLoading(true);
    Job.show(movement?.assignments[0]?.job?.id)
      .then(response => {
        setLoading(false);
        setJob(response);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const expectedAssignments = movement?.assignments?.filter(assignment => {
    if (movementType == 'exports') return assignment.originHubId == hubId;
    else return assignment.destinationHubId == hubId;
  });
  const notExpectedAssignments = movement?.assignments?.filter(assignment => {
    if (movementType == 'exports') return assignment.originHubId != hubId;
    else return assignment.destinationHubId != hubId;
  });

  const waitingForPayment =
    (movementType == 'deliveries' || movementType == 'export') &&
    movement?.assignments[0]?.job?.codRequired &&
    !movement?.assignments[0]?.job?.codReceived;

  const [modalOpen, setModalOpen] = useState();
  const assignmentsForPrinting = movement?.assignments
    ?.map(assignment => (!assignment?.directDelivery ? assignment : null))
    .filter(assignment => {
      return assignment !== null;
    });

  const jobsForPrinting = Object.groupBy(assignmentsForPrinting, ({ job }) => job?.id);

  const getModalTitle = () => {
    switch (modalOpen) {
      case 'mark_arrived':
        return null;
      case 'bay':
        return 'Select Bay';
      case 'print':
        return 'Select a printer';
      case 'start_movement':
        return null;
    }
  };

  const getModalType = () => {
    switch (modalOpen) {
      case 'start_movement':
        return (
          <StartModal
            category={category}
            movement={movement}
            movementType={movementType}
            setModalOpen={setModalOpen}
            refreshMovement={getMovement}
            setFromPending={setFromPending}
          />
        );
      case 'mark_arrived':
        return (
          <div className="blank_modal">
            <div className="message">
              {!movement?.actualArrivalTime
                ? 'Mark this vehicle as arrived?'
                : 'Clear arrival time?'}
            </div>
            <div className="modal_buttons">
              <div className="cancel_button" onClick={() => setModalOpen(false)}>
                Cancel
              </div>
              <div
                className="ok_button"
                onClick={() => setArrivedStatus(!movement?.actualArrivalTime ? true : false)}
              >
                OK
              </div>
            </div>
          </div>
        );
      case 'bay':
        return (
          <EditBay
            bays={bays}
            racks={racks}
            setModalOpen={setModalOpen}
            refetchPackages={getMovement}
            overrideHandleClick={movementType == 'exports' ? setExportBay : setDefaultBay}
          />
        );
      case 'print':
        return <PrintLabel setModalOpen={setModalOpen} jobs={jobsForPrinting} />;
    }
  };

  const setDefaultBay = bay => {
    setLoading(true);
    GoodsIn.updateDefaultBay(category, bay.id, movement?.id)
      .then(() => {
        getMovement();
        setLoading(false);
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setModalOpen(false);
        setError(e.errors || e.error);
      });
  };

  const setExportBay = bay => {
    setLoading(true);
    GoodsOut.updateDefaultBay(category, bay.id, movement?.id)
      .then(() => {
        getMovement();
        setLoading(false);
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setModalOpen(false);
        setError(e.errors || e.error);
      });
  };

  const setArrivedStatus = arrived => {
    if (movementType == 'collections' || movementType == 'imports') {
      setLoading(true);
      GoodsIn.updateArrivalTime(category, arrived ? new Date().toISOString() : null, movement?.id)
        .then(() => {
          getMovement();
          setLoading(false);
          setModalOpen(false);
        })
        .catch(e => {
          setLoading(false);
          setModalOpen(false);
          setError(e.errors || e.error);
        });
    }
    if (movementType == 'deliveries' || movementType == 'exports') {
      setLoading(true);
      GoodsOut.updateArrivalTime(category, arrived ? new Date().toISOString() : null, movement?.id)
        .then(() => {
          getMovement();
          setLoading(false);
          setModalOpen(false);
        })
        .catch(e => {
          setLoading(false);
          setModalOpen(false);
          setError(e.errors || e.error);
        });
    }
  };

  const getBays = async () => {
    setLoading(true);
    Hub.show(hubId)
      .then(response => {
        setBaysAndRacks(response.bays);
        setBays(response.bays.filter(bay => bay.bayType != 'racking'));
        const racks = response.bays.filter(bay => bay.bayType == 'racking');
        setRacks(Object.groupBy(racks, rack => rack.bayNumber));
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const [relatedExports, setRelatedExports] = useState();

  const getRelatedExports = () => {
    setLoading(true);
    const params = { category: 'international', jobId: movement?.assignments[0]?.job?.id };
    GoodsOut.all(params)
      .then(response => {
        setRelatedExports(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getBays();
    if (movement?.assignments?.length > 0) {
      getJob();
    }
    if (movementType == 'collections') {
      getRelatedExports();
    }
  }, []);

  return (
    <div data-testid="pending_container">
      {relatedExports?.map(relatedExport => {
        if (relatedExport.expectedBayId) {
          return (
            <Error
              key={relatedExport.reference}
              errorMessages={`Export trailer ${
                relatedExport?.reference || '(No Groupage)'
              } expects these packages to be loaded from ${`${
                baysAndRacks?.find(b => b.id == relatedExport?.expectedBayId)?.bayType[0]
              }${
                baysAndRacks?.find(b => b.id == relatedExport?.expectedBayId)?.bayNumber
              }`.toUpperCase()}`}
              type={'expected_bay'}
            />
          );
        }
      })}
      <MovementDetails movement={movement} category={category} job={firstJob} />
      {(movementType == 'collections' || movementType == 'deliveries') && (
        <div className="assignment_values">
          <div className="packages_expected_quantity">{'Quantity'}</div>
          <div className="packages_expected_weight">{'Gross Weight'}</div>
          <div className="packages_expected_volume">{'Cubic Metres'}</div>
          <div className="packages_expected_volume">{'Loading Metres'}</div>
          <div className="value">
            {movement?.assignments[0]?.quantity || '0'} {firstJob?.packageType?.shortName || 'pkg'}
          </div>
          <div className="value">{movement?.assignments[0]?.grossWeightKg || '0'} kg</div>

          <div className="value">
            {Number(movement?.assignments[0]?.cubicMetres || 0)?.toFixed(2)} m³
          </div>
          <div className="value">
            {Number(movement?.assignments[0]?.loadingMetres || 0)?.toFixed(2)} m
          </div>
        </div>
      )}
      <MovementNotesPhotos setError={setError} movement={movement} movementType={movementType} />
      <div className="pending_movement_buttons">
        {(movementType == 'collections' ||
          movementType == 'imports' ||
          movementType == 'exports') && (
          <>
            {movementType != 'exports' ? (
              <Button
                buttonType={'light_blue'}
                className="pending_movement_button pre_print_labels light_blue"
                onClick={() => {
                  setModalOpen('print');
                }}
                label={
                  <>
                    <div>Pre-print labels</div>
                    <div className="small">{`${assignmentsForPrinting?.length} job${
                      assignmentsForPrinting?.length > 1 ? 's' : ''
                    }, ${assignmentsForPrinting
                      ?.map(a => a.quantity)
                      .reduce((a, b) => a + b, 0)} label${
                      assignmentsForPrinting?.map(a => a.quantity).reduce((a, b) => a + b, 0) > 1
                        ? 's'
                        : ''
                    }`}</div>
                  </>
                }
              />
            ) : (
              <div className="export_default_bay_text">
                Prior to loading, all packages should be relocated to:
              </div>
            )}
            <Button
              buttonType={'light_blue'}
              className="pending_movement_button expected_bay light_blue"
              onClick={() => setModalOpen('bay')}
              label={
                <>
                  {movementType == 'exports' ? '' : 'Expected Bay: '}
                  {movement?.expectedBayId && baysAndRacks
                    ? `${baysAndRacks?.find(b => b.id == movement?.expectedBayId)?.bayType[0]}${
                        baysAndRacks?.find(b => b.id == movement?.expectedBayId)?.bayNumber
                      }`.toUpperCase()
                    : movementType == 'exports'
                    ? 'Not Specified'
                    : 'None'}
                </>
              }
            />
          </>
        )}
        <Button
          buttonType={movement?.actualArrivalTime ? 'green' : 'red'}
          className={`pending_movement_button arrived ${
            movement?.actualArrivalTime ? 'arrived' : 'not_arrived'
          }`}
          onClick={() => setModalOpen('mark_arrived')}
          label={
            <>
              <div>
                {movement?.actualArrivalTime
                  ? `Arrived ${formatDate(movement?.actualArrivalTime)}`
                  : 'Not arrived'}
              </div>
              <div className="small">
                Expected{' '}
                {new Date(movement?.currentExpectedArrivalDate).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })}
                {movement?.currentExpectedArrivalHour
                  ? `, ${movement?.currentExpectedArrivalHour}`
                  : ''}
              </div>
            </>
          }
        />
        <Button
          className={`pending_movement_button start_unloading ${
            waitingForPayment ? 'disabled' : ''
          }`}
          onClick={() => setModalOpen('start_movement')}
          disabled={waitingForPayment}
          label={`Start ${
            movementType == 'collections' || movementType == 'imports' ? 'Unl' : 'L'
          }oading`}
        />
      </div>
      {(movementType == 'imports' || movementType == 'exports') && (
        <div className="expected_international_packages">
          <div className="section_title">Expected Packages</div>
          <AssignmentList assignments={expectedAssignments} />
          {notExpectedAssignments?.length > 0 && (
            <>
              <div className="section_title">Not Expected</div>
              <AssignmentList assignments={notExpectedAssignments} />
            </>
          )}
        </div>
      )}
      {movementType == 'deliveries' || movementType == 'exports'
        ? jobs?.map(job => {
            return (
              <>
                {movementType == 'exports' && (
                  <div className="job_title" data-testid={`job_title_${job?.jobReference}`}>
                    {job?.jobReference}
                  </div>
                )}
                <AssociatedPackageList
                  key={job?.id}
                  job={job}
                  setLoading={setLoading}
                  hubId={hubId}
                  bays={bays}
                  racks={racks}
                  setError={setError}
                />
              </>
            );
          })
        : ''}
      {modalOpen && (
        <Modal title={getModalTitle()} content={getModalType()} setModalOpen={setModalOpen} />
      )}
    </div>
  );
};

PendingMovement.propTypes = {
  setFromPending: PropTypes.func,
  getMovement: PropTypes.func,
  movement: PropTypes.object,
  setError: PropTypes.func,
  setLoading: PropTypes.func,
  category: PropTypes.string,
  movementType: PropTypes.string,
};

export default PendingMovement;
